import { Box, Grid } from "@material-ui/core";
import {
    ChampionshipType,
    useCurrentSeason,
    usePublicsChampionships,
    useSeasonOptions,
} from "api";
import React, {useCallback, useContext, useMemo, useState} from "react";
import { ChampionshipCard } from "ui/componentes/ChampionshipCard";
import { LoggedUserContext } from "ui/componentes";
import CustomSelect from "ui/componentes/Form/SelectFieldFormik/CustomSelect";
import {useSelector, useDispatch} from "react-redux";
import {RootState} from "../../../redux/model";

const Home = () => {
    const selectedSeason = useSelector((state: RootState) => state.seasonAppReducer.selectedSeason)
    const dispatch = useDispatch();

    const setSelectedSeason = useCallback((seasonId: string) => {
        dispatch({type: "SET_SELECTED_SEASON", data: {selectedSeason: seasonId}})
    }, []);

    const currentSeason = useCurrentSeason();
    const seasonOptions = useSeasonOptions();
    const { isAdmin } = useContext(LoggedUserContext);

    const championships = usePublicsChampionships().filter(
        (champ) => champ.seasonId === (selectedSeason || currentSeason?.id)
    );

    const orderedChampionships = useMemo(() => {
        const ovals = championships
            .filter((champ) => champ.championshipType === ChampionshipType.OVAL)
            .sort((c1, c2) => (c1.name < c2.name ? -1 : 1));
        const roads = championships
            .filter((champ) => champ.championshipType === ChampionshipType.ROAD)
            .sort((c1, c2) => (c1.name < c2.name ? -1 : 1));
        return [...ovals, ...roads];
    }, [championships]);

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
        >
            <Box width="80%" marginTop={3}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <CustomSelect
                            label="Temporada"
                            options={seasonOptions}
                            onChange={(v) =>
                                setSelectedSeason(v.target.value)
                            }
                            value={selectedSeason}
                        />
                    </Grid>
                    {orderedChampionships.map((champ) => (
                        <Grid key={champ.id} item xs={12} md={6}>
                            <ChampionshipCard championship={champ} />
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Box>
    );
};

export { Home };
